export default function Button() {
  return <button>Learn More</button>;
}
